// extracted by mini-css-extract-plugin
export default {"filter":"QuestionList_filter__53bh7","fadeIn":"QuestionList_fadeIn__HfmPB","tblheader":"QuestionList_tblheader__aeBP2","btn":"QuestionList_btn__muTra"};